// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__5p6S0","rootSuccess":"CompleteLink_rootSuccess__24LZA","rootFailure":"CompleteLink_rootFailure__1hPLH","isDisabled":"CompleteLink_isDisabled__1GgLG"};